import React from "react";
import { useSpring, animated } from "react-spring";

function IncrementTansition3(props) {
  const { number } = useSpring({
    from: { number: 0 },
    number: props.n,
    delay: 800,
    config: {
      mass: 1,
      tension: 20,
      friction: 10,
      duration: 1000,
    },
  });

  const decimalPlaces = props.n?.toString().includes(".") ? props.n.toString().split(".")[1].length : 0;

  const formattedNumber = number.to((n) => `${props.symbol1 || ""} ${n.toFixed(decimalPlaces)} ${props.symbol2 || ""}`);

  return !props.large ? (
    <animated.h2 className={props.className}>{formattedNumber}</animated.h2>
  ) : (
    <animated.h1 className={props.className}>{formattedNumber}</animated.h1>
  );
}

export default IncrementTansition3;